/**
 * Stöberecke 2.0 – Fullscreen Produkt-Feed
 * Thumb-Zone · Smart Hide · Collection-Based
 */
(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     Elemente
     ----------------------------------------------------------------------- */
  var trigger    = document.getElementById('stoberecke-trigger');
  var overlay    = document.getElementById('stoberecke-overlay');
  var panel      = document.getElementById('stoberecke-panel');
  var feed       = document.getElementById('stoberecke-feed');
  var closeBtn   = document.getElementById('stoberecke-close');
  var scrollHint = document.getElementById('stoberecke-scroll-hint');
  var dataEl     = document.getElementById('stoberecke-products');
  var detailPanel = document.getElementById('stoberecke-detail');
  var detailBody  = document.getElementById('stoberecke-detail-body');
  var detailBack  = document.getElementById('stoberecke-detail-back');
  var fabBack     = detailBack; /* Back-Button ist jetzt im FAB */

  if (!overlay || !feed || !dataEl) return;

  /* -----------------------------------------------------------------------
     Produkte laden & shuffeln (Fisher-Yates)
     ----------------------------------------------------------------------- */
  var products = [];
  try {
    products = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Stöberecke: Produktdaten konnten nicht gelesen werden.', e);
    return;
  }

  if (products.length === 0) {
    if (trigger) trigger.style.display = 'none';
    return;
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  /* Deduplizieren (Produkt kann in mehreren Kollektionen sein) */
  var _seen = {};
  products = products.filter(function (p) {
    if (_seen[p.id]) return false;
    _seen[p.id] = true;
    return true;
  });

  shuffle(products);

  /* -----------------------------------------------------------------------
     Karten erstellen
     ----------------------------------------------------------------------- */
  var cartIconUrl = window.stobereckeCartIconUrl || '';

  function renderCard(el, isFirst) {
    var index = parseInt(el.dataset.index, 10);
    var product = products[index];
    if (!product) return;

    /* Bilder: falls mehrere vorhanden → Gallery mit Dots */
    var imgs = product.images && product.images.length > 0
      ? product.images
      : [{ src: product.image, alt: product.image_alt }];

    var galleryHtml = '';
    for (var g = 0; g < imgs.length; g++) {
      /* Erstes Bild der ersten Karte: eager (LCP-optimiert), Rest: lazy */
      var loadAttr = (isFirst && g === 0) ? 'eager' : 'lazy';
      galleryHtml +=
        '<div class="stoberecke-card__gallery-slide">' +
          '<img class="stoberecke-card__image"' +
          ' src="' + escapeAttr(imgs[g].src) + '"' +
          ' alt="' + escapeAttr(imgs[g].alt) + '"' +
          ' decoding="async" loading="' + loadAttr + '">' +
        '</div>';
    }

    var dotsHtml = '';
    if (imgs.length > 1) {
      dotsHtml = '<div class="stoberecke-card__dots">';
      for (var d = 0; d < imgs.length; d++) {
        dotsHtml += '<span class="stoberecke-card__dot' +
          (d === 0 ? ' stoberecke-card__dot--active' : '') + '"></span>';
      }
      dotsHtml += '</div>';
    }

    /* Kollektions-Badge (z.B. "zu finden in Kuscheldecken") */
    var collHtml = '';
    if (product.collection_title && product.collection_url) {
      collHtml = '<a class="stoberecke-card__collection" href="' + escapeAttr(product.collection_url) + '">' +
        'zu finden in <strong>' + escapeHtml(product.collection_title) + '</strong>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>' +
      '</a>';
    }

    el.innerHTML =
      '<div class="stoberecke-card__header">' +
        '<h2 class="stoberecke-card__title">' + escapeHtml(product.title) + '</h2>' +
        '<p class="stoberecke-card__price">' + product.price + '</p>' +
        collHtml +
      '</div>' +
      '<div class="stoberecke-card__image-wrap">' +
        '<div class="stoberecke-card__image-container">' +
          '<div class="stoberecke-card__gallery">' + galleryHtml + '</div>' +
          dotsHtml +
          '<button class="fav-btn stoberecke-card__fav-btn' + (window.Favorites && window.Favorites.isActive(product.id) ? ' fav-btn--active' : '') + '" data-product-id="' + product.id + '" type="button" aria-label="' + (window.Favorites && window.Favorites.isActive(product.id) ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufuegen') + '">' +
            '<svg class="fav-btn__icon fav-btn__icon--empty" aria-hidden="true" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/></svg>' +
            '<svg class="fav-btn__icon fav-btn__icon--filled" aria-hidden="true" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0z"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="stoberecke-card__actions">' +
        '<button' +
        ' class="stoberecke-card__btn stoberecke-card__btn--cart"' +
        ' data-variant-id="' + product.variant_id + '"' +
        ' type="button"' +
        ' aria-label="' + escapeAttr(product.title) + ' in den Warenkorb"' +
        '>' +
          '<svg class="stoberecke-card__btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 3c4 0 7 2.5 7 6l0 2"></path>' +
            '<polyline points="16 9 19 11 22 9"></polyline>' +
          '</svg>' +
          '<img src="' + escapeAttr(cartIconUrl).replace('icon-cart.svg', 'icon-cart-empty.svg') + '" alt="" width="54" height="54">' +
        '</button>' +
        '<button' +
        ' class="stoberecke-card__btn stoberecke-card__btn--info"' +
        ' type="button"' +
        ' aria-label="Mehr Infos zu ' + escapeAttr(product.title) + '"' +
        '>' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="12" cy="12" r="10"></circle>' +
            '<line x1="12" y1="16" x2="12" y2="12"></line>' +
            '<line x1="12" y1="8" x2="12.01" y2="8"></line>' +
          '</svg>' +
          '<span>Mehr Infos</span>' +
        '</button>' +
      '</div>';

    /* Gallery: immer beim ersten Bild starten + Dots aktualisieren */
    if (imgs.length > 1) {
      var gallery = el.querySelector('.stoberecke-card__gallery');
      var dotEls  = el.querySelectorAll('.stoberecke-card__dot');

      /* -----------------------------------------------------------
         Scroll-Snap temporär deaktivieren, scrollLeft hart auf 0
         setzen und nach dem Laden des ersten Bildes wieder
         aktivieren. Damit kann der Browser den Scroll nicht mehr
         auf ein zufälliges Bild snappen.
         ----------------------------------------------------------- */
      gallery.style.scrollSnapType = 'none';
      gallery.scrollLeft = 0;

      var firstImg = gallery.querySelector('img');
      function resetGallery() {
        gallery.scrollLeft = 0;
        /* Scroll-Snap erst nach dem Reset wieder einschalten */
        requestAnimationFrame(function () {
          gallery.scrollLeft = 0;
          gallery.style.scrollSnapType = '';
        });
      }

      if (firstImg && firstImg.complete) {
        resetGallery();
      } else if (firstImg) {
        firstImg.addEventListener('load', resetGallery, { once: true });
        /* Fallback falls Bild aus dem Cache kommt ohne load-Event */
        setTimeout(resetGallery, 500);
      }

      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        for (var i = 0; i < dotEls.length; i++) {
          dotEls[i].classList.toggle('stoberecke-card__dot--active', i === idx);
        }
      }, { passive: true });
    }
  }

  /* -----------------------------------------------------------------------
     Feed initialisieren
     ----------------------------------------------------------------------- */
  var initialized = false;

  function initFeed() {
    feed.innerHTML = '';
    for (var i = 0; i < products.length; i++) {
      var el = document.createElement('div');
      el.className = 'stoberecke-card';
      el.dataset.index = i;
      feed.appendChild(el);
      renderCard(el, i === 0);
    }
    initialized = true;
    /* Favoriten-Status auf alle neuen Buttons anwenden */
    if (window.Favorites && window.Favorites.refresh) {
      window.Favorites.refresh();
    }
  }

  /* -----------------------------------------------------------------------
     Peek-Overlay erzeugen (grauer Schleier + Swipe-Pfeil)
     ----------------------------------------------------------------------- */
  var peekOverlay = document.createElement('div');
  peekOverlay.className = 'stoberecke-peek-overlay';
  peekOverlay.innerHTML =
    '<svg class="stoberecke-peek-overlay__arrow" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 19V5"></path>' +
      '<path d="M5 12l7-7 7 7"></path>' +
    '</svg>' +
    '<span class="stoberecke-peek-overlay__text">' +
      '<span class="stoberecke-peek-overlay__text-main">Scrolle</span>' +
      '<span class="stoberecke-peek-overlay__text-sub">für weitere Produkte</span>' +
    '</span>';
  document.getElementById('stoberecke-panel').appendChild(peekOverlay);

  /* -----------------------------------------------------------------------
     Peek-Animation: hochscrollen → Overlay → zurückschnappen + Bounce
     ----------------------------------------------------------------------- */
  var peekCancelled = false;
  var peekTimers = [];

  function cancelPeek() {
    if (peekCancelled) return;
    peekCancelled = true;
    /* Alle laufenden Timer stoppen */
    for (var t = 0; t < peekTimers.length; t++) clearTimeout(peekTimers[t]);
    peekTimers = [];
    /* Overlay sofort ausblenden */
    peekOverlay.classList.remove('stoberecke-peek-overlay--visible');
    /* Feed + Karte zurücksetzen */
    feed.style.scrollSnapType = '';
    var fc = feed.firstElementChild;
    if (fc) { fc.style.transition = ''; fc.style.transform = ''; }
  }

  function peekFeed() {
    if (products.length <= 1) return;
    var firstCard = feed.firstElementChild;
    if (!firstCard) return;

    peekCancelled = false;
    peekTimers = [];

    /* Jede Interaktion bricht die Peek-Animation sofort ab */
    function onCancel() { cancelPeek(); cleanup(); }
    function cleanup() {
      feed.removeEventListener('touchstart', onCancel);
      feed.removeEventListener('pointerdown', onCancel);
      feed.removeEventListener('wheel', onCancel);
      panel.removeEventListener('click', onCancel);
    }
    feed.addEventListener('touchstart', onCancel, { passive: true, once: true });
    feed.addEventListener('pointerdown', onCancel, { passive: true, once: true });
    feed.addEventListener('wheel', onCancel, { passive: true, once: true });
    panel.addEventListener('click', onCancel, { once: true });

    var cardH = firstCard.offsetHeight;
    var peekDist = Math.min(cardH * 0.4, cardH - 120);

    peekTimers.push(setTimeout(function () {
      if (peekCancelled) { cleanup(); return; }

      feed.style.scrollSnapType = 'none';

      /* Phase 1: Sanft hochgleiten */
      animateScroll(0, peekDist, 700, easeInOutCubic, function () {
        if (peekCancelled) return;

        /* Phase 2: Overlay einblenden */
        peekOverlay.classList.add('stoberecke-peek-overlay--visible');

        /* Pause — Overlay mit Pfeil + Text sichtbar (2s) */
        peekTimers.push(setTimeout(function () {
          if (peekCancelled) return;

          /* Overlay ausblenden */
          peekOverlay.classList.remove('stoberecke-peek-overlay--visible');

          /* Kurz warten bis Overlay gefadet, dann zurückschnappen */
          peekTimers.push(setTimeout(function () {
            if (peekCancelled) return;

            /* Phase 3: Zurückschnappen (schnell) */
            animateScroll(peekDist, 0, 350, easeOutQuart, function () {
              if (peekCancelled) return;

              /* Phase 4: Kräftiger Rubber-Band-Abpraller */
              firstCard.style.transition = 'transform 0.15s ease-out';
              firstCard.style.transform = 'translateY(40px)';

              peekTimers.push(setTimeout(function () {
                if (peekCancelled) return;
                /* Gegenschwung */
                firstCard.style.transition = 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)';
                firstCard.style.transform = 'translateY(-15px)';

                peekTimers.push(setTimeout(function () {
                  if (peekCancelled) return;
                  /* Kleiner Nachschwung */
                  firstCard.style.transition = 'transform 0.2s ease-out';
                  firstCard.style.transform = 'translateY(5px)';

                  peekTimers.push(setTimeout(function () {
                    if (peekCancelled) return;
                    /* Einrasten */
                    firstCard.style.transition = 'transform 0.15s ease-out';
                    firstCard.style.transform = 'translateY(0)';

                    peekTimers.push(setTimeout(function () {
                      firstCard.style.transition = '';
                      firstCard.style.transform = '';
                      feed.style.scrollSnapType = '';
                      cleanup();
                    }, 200));
                  }, 200));
                }, 300));
              }, 150));
            });
          }, 350));
        }, 2000));
      });
    }, 2000));
  }

  /* requestAnimationFrame-basierte Scroll-Animation */
  function animateScroll(from, to, duration, easing, cb) {
    var diff = to - from;
    var t0 = null;
    function step(ts) {
      if (peekCancelled) return; /* Animation sofort stoppen */
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / duration, 1);
      feed.scrollTop = from + diff * easing(p);
      if (p < 1) requestAnimationFrame(step);
      else if (cb) cb();
    }
    requestAnimationFrame(step);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  /* -----------------------------------------------------------------------
     Welcome-Screen (nur beim allerersten Öffnen)
     ----------------------------------------------------------------------- */
  var welcomeEl  = document.getElementById('stoberecke-welcome');
  var welcomeBtn = document.getElementById('stoberecke-welcome-btn');
  var WELCOME_KEY = 'stoberecke_welcomed';
  var welcomeDismissTimer = null;

  function resetWelcomeState() {
    if (!welcomeEl) return;
    if (welcomeDismissTimer) {
      clearTimeout(welcomeDismissTimer);
      welcomeDismissTimer = null;
    }
    welcomeEl.classList.remove('stoberecke-welcome--visible', 'stoberecke-welcome--fade-out');
    welcomeEl.setAttribute('aria-hidden', 'true');
  }

  function showWelcome() {
    if (!welcomeEl || localStorage.getItem(WELCOME_KEY)) return false;
    resetWelcomeState();
    welcomeEl.classList.add('stoberecke-welcome--visible');
    welcomeEl.setAttribute('aria-hidden', 'false');
    return true;
  }

  function dismissWelcome() {
    if (!welcomeEl) return;
    welcomeEl.classList.add('stoberecke-welcome--fade-out');
    welcomeEl.classList.remove('stoberecke-welcome--visible');
    welcomeEl.setAttribute('aria-hidden', 'true');
    localStorage.setItem(WELCOME_KEY, '1');
    sessionStorage.setItem('stoberecke_peeked', '1');
    welcomeDismissTimer = setTimeout(function () {
      resetWelcomeState();
    }, 450);
    /* Peek erst starten nachdem Welcome-Fadeout fertig ist (400ms CSS-Transition) */
    setTimeout(function () { peekFeed(); }, 450);
  }

  if (welcomeBtn) {
    welcomeBtn.addEventListener('click', dismissWelcome);
  }

  /* -----------------------------------------------------------------------
     Overlay öffnen / schließen
     ----------------------------------------------------------------------- */
  var isOpen = false;
  overlay.hidden = true;

  function openOverlay() {
    if (isOpen) return;
    isOpen = true;

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('stoberecke-no-scroll');
    feed.scrollTop = 0;
    requestAnimationFrame(function () {
      overlay.classList.add('stoberecke-overlay--open');
    });

    track('overlay_opened');

    /* Scroll-Hint ist jetzt rein peek-gesteuert, kein manuelles Toggle */

    if (!initialized) {
      initFeed();
      /* Welcome-Screen zeigen oder direkt Peek starten (nur 1× pro Session) */
      if (!showWelcome()) {
        if (!sessionStorage.getItem('stoberecke_peeked')) {
          sessionStorage.setItem('stoberecke_peeked', '1');
          peekFeed();
        }
      }
    }

    closeBtn.focus();
  }

  function closeOverlay() {
    if (!isOpen) return;
    isOpen = false;
    cancelPeek();
    resetWelcomeState();
    hideDetail();
    overlay.classList.remove('stoberecke-overlay--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('stoberecke-no-scroll');
    overlay.hidden = true;
    if (trigger) trigger.focus();
  }

  if (trigger) trigger.addEventListener('click', function () {
    openOverlay();
  });
  closeBtn.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeOverlay();
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeOverlay();
  });

  /* -----------------------------------------------------------------------
     Menü-Link #stoberecke
     ----------------------------------------------------------------------- */
  function checkHash() {
    if (window.location.hash === '#stoberecke') {
      openOverlay();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
  checkHash();

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#stoberecke"]');
    if (link) { e.preventDefault(); openOverlay(); }
  });

  /* Custom Event für externe Trigger (z.B. Favoriten-Seite) */
  document.addEventListener('stoberecke:open', function () { openOverlay(); });

  /* -----------------------------------------------------------------------
     Smart Hide: Buttons beim Scrollen ausblenden, beim Stopp einblenden
     ----------------------------------------------------------------------- */
  var scrollTimer;
  feed.addEventListener('scroll', function () {
    if (panel) panel.classList.add('stoberecke-panel--scrolling');
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      if (panel) panel.classList.remove('stoberecke-panel--scrolling');
    }, 400);
  }, { passive: true });

  /* -----------------------------------------------------------------------
     Scroll-Hinweis ausblenden
     ----------------------------------------------------------------------- */
  /* Scroll-Hint wird nur durch peekFeed() ein-/ausgeblendet,
     kein separater Scroll-Listener nötig */

  /* -----------------------------------------------------------------------
     Fähnchen: Position dynamisch unterhalb des echten Headers setzen
     ----------------------------------------------------------------------- */
  function positionTrigger() {
    if (!trigger) return;
    if (window.innerWidth <= 749) return; /* Mobile: CSS top:50% bleibt */
    var headerEl =
      document.querySelector('#shopify-section-header sticky-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('[role="banner"]') ||
      document.querySelector('header');
    if (!headerEl) return;
    var bottom = headerEl.getBoundingClientRect().bottom;
    trigger.style.top       = Math.max(bottom + 16, 60) + 'px';
    trigger.style.transform = 'translateX(0)';
  }

  var _raf = false;
  window.addEventListener('scroll', function () {
    if (!_raf) {
      _raf = true;
      requestAnimationFrame(function () { positionTrigger(); _raf = false; });
    }
  }, { passive: true });
  window.addEventListener('resize', positionTrigger, { passive: true });

  /* -----------------------------------------------------------------------
     Floating Button nach 1 Sekunde einblenden
     ----------------------------------------------------------------------- */
  if (trigger) {
    setTimeout(function () {
      trigger.classList.add('stoberecke-trigger--visible');
      positionTrigger();
    }, 1000);

    // FAB: Kein Retract nötig, Button ist kompakt und immer sichtbar
  }

  /* -----------------------------------------------------------------------
     Detail-Ansicht: "Mehr Infos" öffnet Produktbeschreibung im Overlay
     ----------------------------------------------------------------------- */
  function showDetail(product) {
    if (!detailPanel || !detailBody) return;
    detailPanel.classList.add('stoberecke-detail--open');
    detailPanel.setAttribute('aria-hidden', 'false');
    /* FAB Zurück-Button einblenden */
    if (fabBack) fabBack.classList.add('stoberecke-fab__back--visible');

    var desc = product.description && product.description.trim()
      ? '<div class="stoberecke-detail__description">' + product.description + '</div>'
      : '<p class="stoberecke-detail__no-desc">Zu diesem Produkt gibt es noch keine Beschreibung.</p>';

    detailBody.innerHTML =
      '<h2 class="stoberecke-detail__title">' + escapeHtml(product.title) + '</h2>' +
      '<p class="stoberecke-detail__price">' + product.price + '</p>' +
      desc +
      '<a class="stoberecke-detail__link" href="' + escapeAttr(product.url) + '">Zur Produktseite →</a>';
  }

  function hideDetail() {
    if (!detailPanel) return;
    detailPanel.classList.remove('stoberecke-detail--open');
    detailPanel.setAttribute('aria-hidden', 'true');
    /* FAB Zurück-Button ausblenden */
    if (fabBack) fabBack.classList.remove('stoberecke-fab__back--visible');
  }

  /* Klick auf "Mehr Infos" abfangen */
  feed.addEventListener('click', function (e) {
    var btn = e.target.closest('.stoberecke-card__btn--info');
    if (!btn) return;
    e.preventDefault();
    var idx = parseInt(btn.closest('.stoberecke-card').dataset.index, 10);
    var product = products[idx];
    if (product) {
      showDetail(product);
      track('detail_opened', { product_title: product.title, product_id: product.id });
    }
  });

  if (detailBack) {
    detailBack.addEventListener('click', hideDetail);
  }

  /* -----------------------------------------------------------------------
     Warenkorb – AJAX Add to Cart
     ----------------------------------------------------------------------- */
  feed.addEventListener('click', function (e) {
    var btn = e.target.closest('.stoberecke-card__btn--cart');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="stoberecke-spinner"></span>';

    /* Optimistisches Update: Cart-Bubble sofort hochzählen */
    var _bubbleEls = document.querySelectorAll('.cart-count-bubble [aria-hidden="true"]');
    var _prevCounts = [];
    _bubbleEls.forEach(function (el, i) {
      _prevCounts[i] = el.textContent;
      el.textContent = String((parseInt(el.textContent, 10) || 0) + 1);
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      b.classList.remove('hidden');
    });

    /* Dawns product-form.js pattern: sections mitsenden */
    var cartEl = document.querySelector('cart-notification') ||
                 document.querySelector('cart-drawer');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cartEl && cartEl.getSectionsToRender) {
      formData.append(
        'sections',
        cartEl.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Fehler'); });
        return res.json();
      })
      .then(function (response) {
        /* Cart-Icon Bubble sofort aktualisieren */
        if (cartEl && cartEl.renderContents) {
          cartEl.renderContents(response);
        }

        btn.classList.add('is-added');
        btn.innerHTML = '<span style="font-size:2rem;color:#fff">✓</span>';

        track('add_to_cart', { variant_id: variantId });

        /* Warenkorbseite: Seite neu laden damit der Inhalt stimmt */
        if (/^\/cart\b/.test(window.location.pathname)) {
          setTimeout(function () { window.location.reload(); }, 800);
          return;
        }

        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }, 2000);
      })
      .catch(function (err) {
        /* Optimistisches Update rückgängig machen */
        _bubbleEls.forEach(function (el, i) { el.textContent = _prevCounts[i]; });
        btn.innerHTML = '<span style="font-size:1.1rem;color:#fff">Fehler – nochmal?</span>';
        console.warn('Stöberecke Cart:', err.message);
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }, 2500);
      });
  });

  /* -----------------------------------------------------------------------
     "Zurück zur Stöberecke"-Button auf Produktseiten
     ----------------------------------------------------------------------- */
  var RETURN_KEY = 'stoberecke_came_from';

  /* Flag setzen wenn jemand aus der Detail-Ansicht zur Produktseite geht */
  if (detailBody) {
    detailBody.addEventListener('click', function (e) {
      var link = e.target.closest('.stoberecke-detail__link');
      if (link) {
        sessionStorage.setItem(RETURN_KEY, '1');
        track('click_product_page', { url: link.href });
      }
    });
  }

  /* Kollektions-Link: Tracking + Return-Flag setzen */
  feed.addEventListener('click', function (e) {
    var collLink = e.target.closest('.stoberecke-card__collection');
    if (collLink) {
      sessionStorage.setItem(RETURN_KEY, '1');
      track('click_collection', { url: collLink.href, collection: collLink.textContent.trim() });
    }
  });

  /* Prüfen ob User aus der Stöberecke kam → Return-Button statt Trigger */
  var showReturn = sessionStorage.getItem(RETURN_KEY);
  if (showReturn && trigger) {
    /* Auf Seiten mit Trigger (z.B. Kollektionsseiten): Trigger verstecken */
    trigger.style.display = 'none';
  }
  if (showReturn) {
    var returnBtn = document.createElement('button');
    returnBtn.className = 'stoberecke-return';
    returnBtn.setAttribute('type', 'button');
    returnBtn.setAttribute('aria-label', 'Zurück zur Stöberecke');
    returnBtn.innerHTML =
      '<svg class="stoberecke-return__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="15 18 9 12 15 6"></polyline>' +
      '</svg>' +
      '<svg class="stoberecke-return__lamp" aria-hidden="true" width="36" height="36" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none">' +
        '<path d="M40.2,13.6c0-3.6-16-3.6-16,0v.2h16v-.2Z" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<polygon points="39.3 30.6 25 30.6 25.6 13.9 38.8 13.9 39.3 30.6" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<path d="M40.3,55.4c0,1.4-16.2,1.4-16.2,0l.6-10.6h14.9l.6,10.6Z" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="26.8" y1="31.2" x2="26.8" y2="44.2" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="22.5" y1="30.6" x2="41.9" y2="30.6" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="32.2" y1="40.4" x2="32.2" y2="42.8" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<rect x="29.5" y="42.8" width="5.3" height="2.5" fill="currentColor"/>' +
        '<line x1="37.6" y1="31.2" x2="37.6" y2="44.2" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<path d="M33.8,37.3c0,1.7-1.6,3.1-1.6,3.1,0,0-1.6-1.4-1.6-3.1s1.6-3.1,1.6-3.1c0,0,1.6,1.4,1.6,3.1Z" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<polygon points="34.3 20.4 32.7 22 35.2 24.4 34.6 25 32.2 22.5 29.8 25 29.2 24.4 31.7 22 30.1 20.4 29.4 21 28.8 20.4 29.4 19.8 29.2 19.6 29.8 19 30 19.2 30.6 18.6 31.2 19.2 30.6 19.9 32.2 21.5 33.8 19.9 33.1 19.3 33.8 18.5 34.5 19.2 34.6 19 35.2 19.6 35 19.7 35.6 20.3 35.6 21 34.9 21 34.3 20.4" fill="currentColor"/>' +
        '<path d="M31.1,6.6c2.8,0,2.8,4.3,0,4.3" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<path d="M22.5,44.8c6.6.6,13.1.7,19.4,0" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="47.5" y1="36.5" x2="55" y2="36.5" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="46.8" y1="29.5" x2="54" y2="27" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="47.4" y1="44.3" x2="54.1" y2="45.6" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="9" y1="36.5" x2="16.5" y2="36.5" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="9.9" y1="27" x2="17.2" y2="29.5" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
        '<line x1="9.9" y1="45.6" x2="16.6" y2="44.3" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"/>' +
      '</svg>' +
      '<span>Zurück zur Stöberecke</span>';
    document.body.appendChild(returnBtn);

    /* Sanft reingleiten lassen – kurz warten damit die Seite erst ankommen darf */
    setTimeout(function () {
      returnBtn.classList.add('stoberecke-return--visible');
    }, 1500);

    /* Beim Scrollen: Button einklappen, nur Pfeil sichtbar */
    var returnScrollTimer;
    var returnCollapsed = false;
    window.addEventListener('scroll', function () {
      if (!returnCollapsed) {
        returnCollapsed = true;
        returnBtn.classList.add('stoberecke-return--collapsed');
      }
      clearTimeout(returnScrollTimer);
      returnScrollTimer = setTimeout(function () {
        /* Nach Scroll-Stop: ausgeklappt lassen – User hat Interesse verloren.
           Erst bei Hover/Tap wieder aufklappen */
      }, 600);
    }, { passive: true });

    /* Bei Hover oder Touch: wieder aufklappen */
    returnBtn.addEventListener('mouseenter', function () {
      returnBtn.classList.remove('stoberecke-return--collapsed');
      returnCollapsed = false;
    });
    returnBtn.addEventListener('touchstart', function () {
      if (returnCollapsed) {
        returnBtn.classList.remove('stoberecke-return--collapsed');
        returnCollapsed = false;
      }
    }, { passive: true });

    returnBtn.addEventListener('click', function () {
      sessionStorage.removeItem(RETURN_KEY);
      track('return_to_stoberecke');
      openOverlay();
      /* Button ausblenden */
      returnBtn.classList.remove('stoberecke-return--visible');
      setTimeout(function () { returnBtn.remove(); }, 500);
    });
  }

  /* Flag löschen wenn Stöberecke geschlossen wird */
  overlay.addEventListener('transitionend', function () {
    if (!isOpen) sessionStorage.removeItem(RETURN_KEY);
  });

  /* -----------------------------------------------------------------------
     Tracking: Custom Events für Analytics (GA4 / Shopify / Pixel)
     ----------------------------------------------------------------------- */
  function track(eventName, data) {
    /* Google Analytics 4 (gtag) */
    if (typeof gtag === 'function') {
      gtag('event', eventName, data || {});
    }
    /* Shopify Analytics / Custom Pixel via CustomEvent */
    try {
      document.dispatchEvent(new CustomEvent('stoberecke:' + eventName, { detail: data || {} }));
    } catch (e) { /* IE-Fallback: ignorieren */ }
  }

  /* -----------------------------------------------------------------------
     Lightbox: Vollbild-Bildansicht mit Zoom
     ----------------------------------------------------------------------- */
  var lightbox = null;
  var lbTrack, lbDots, lbCounter, lbImgs;
  var lbCurrentIndex = 0;
  var lbIsZoomed = false;

  function createLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'stoberecke-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-label', 'Bildansicht');
    lightbox.innerHTML =
      '<button class="stoberecke-lightbox__close" aria-label="Schließen">✕</button>' +
      '<button class="stoberecke-lightbox__arrow stoberecke-lightbox__arrow--prev" aria-label="Vorheriges Bild">‹</button>' +
      '<button class="stoberecke-lightbox__arrow stoberecke-lightbox__arrow--next" aria-label="Nächstes Bild">›</button>' +
      '<div class="stoberecke-lightbox__counter"></div>' +
      '<div class="stoberecke-lightbox__track"></div>' +
      '<div class="stoberecke-lightbox__dots"></div>';
    document.body.appendChild(lightbox);

    lbTrack   = lightbox.querySelector('.stoberecke-lightbox__track');
    lbDots    = lightbox.querySelector('.stoberecke-lightbox__dots');
    lbCounter = lightbox.querySelector('.stoberecke-lightbox__counter');

    /* Schließen */
    lightbox.querySelector('.stoberecke-lightbox__close').addEventListener('click', closeLightbox);

    /* Pfeile */
    lightbox.querySelector('.stoberecke-lightbox__arrow--prev').addEventListener('click', function () {
      lbGoTo(lbCurrentIndex - 1);
    });
    lightbox.querySelector('.stoberecke-lightbox__arrow--next').addEventListener('click', function () {
      lbGoTo(lbCurrentIndex + 1);
    });

    /* Klick auf Hintergrund = schließen */
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    /* Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('stoberecke-lightbox--open')) {
        closeLightbox();
      }
      if (e.key === 'ArrowLeft' && lightbox.classList.contains('stoberecke-lightbox--open')) {
        lbGoTo(lbCurrentIndex - 1);
      }
      if (e.key === 'ArrowRight' && lightbox.classList.contains('stoberecke-lightbox--open')) {
        lbGoTo(lbCurrentIndex + 1);
      }
    });

    /* Scroll-Dots aktualisieren */
    lbTrack.addEventListener('scroll', function () {
      var idx = Math.round(lbTrack.scrollLeft / lbTrack.offsetWidth);
      if (idx !== lbCurrentIndex) {
        lbCurrentIndex = idx;
        lbUpdateDots();
      }
    }, { passive: true });
  }

  function openLightbox(images, startIndex) {
    if (!lightbox) createLightbox();

    lbImgs = images;
    lbCurrentIndex = startIndex || 0;
    lbIsZoomed = false;

    /* Slides bauen */
    var html = '';
    for (var i = 0; i < images.length; i++) {
      html += '<div class="stoberecke-lightbox__slide">' +
        '<img class="stoberecke-lightbox__img" src="' + escapeAttr(images[i].src) + '"' +
        ' alt="' + escapeAttr(images[i].alt || '') + '" draggable="false">' +
        '</div>';
    }
    lbTrack.innerHTML = html;

    /* Dots bauen */
    if (images.length > 1) {
      var dotsHtml = '';
      for (var d = 0; d < images.length; d++) {
        dotsHtml += '<span class="stoberecke-lightbox__dot' +
          (d === lbCurrentIndex ? ' stoberecke-lightbox__dot--active' : '') + '"></span>';
      }
      lbDots.innerHTML = dotsHtml;
      lbDots.style.display = '';
    } else {
      lbDots.style.display = 'none';
    }

    /* Counter */
    lbUpdateDots();

    /* Zum Start-Bild scrollen */
    lbTrack.style.scrollSnapType = 'none';
    lbTrack.scrollLeft = lbCurrentIndex * lbTrack.offsetWidth;
    requestAnimationFrame(function () {
      lbTrack.scrollLeft = lbCurrentIndex * lbTrack.offsetWidth;
      lbTrack.style.scrollSnapType = '';
    });

    /* Öffnen */
    lightbox.classList.add('stoberecke-lightbox--open');
    document.body.style.overflow = 'hidden';

    /* Desktop: Klick auf Bild = Zoom */
    var imgEls = lbTrack.querySelectorAll('.stoberecke-lightbox__img');
    for (var j = 0; j < imgEls.length; j++) {
      (function (img) {
        img.addEventListener('click', function (e) {
          if (lbIsZoomed) {
            /* Zoom zurücksetzen */
            img.classList.remove('stoberecke-lightbox__img--zoomed');
            img.style.transform = '';
            lbIsZoomed = false;
            lbTrack.style.overflow = '';
          } else {
            /* Nur auf Desktop zoomen (nicht bei Touch-Pinch) */
            if ('ontouchstart' in window) return;
            var rect = img.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width * 100);
            var y = ((e.clientY - rect.top) / rect.height * 100);
            img.style.setProperty('--zoom-x', x + '%');
            img.style.setProperty('--zoom-y', y + '%');
            img.classList.add('stoberecke-lightbox__img--zoomed');
            img.style.transform = 'scale(2)';
            lbIsZoomed = true;
            lbTrack.style.overflow = 'hidden';
          }
        });

        /* Desktop: Maus-Panning im Zoom-Modus */
        img.addEventListener('mousemove', function (e) {
          if (!lbIsZoomed) return;
          var rect = img.parentElement.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width * 100);
          var y = ((e.clientY - rect.top) / rect.height * 100);
          img.style.transformOrigin = x + '% ' + y + '%';
        });
      })(imgEls[j]);
    }

    track('lightbox_opened', { image_count: images.length, start_index: startIndex });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('stoberecke-lightbox--open');
    document.body.style.overflow = '';
    lbIsZoomed = false;
  }

  function lbGoTo(idx) {
    if (!lbImgs || idx < 0 || idx >= lbImgs.length) return;
    lbCurrentIndex = idx;
    lbTrack.scrollTo({ left: idx * lbTrack.offsetWidth, behavior: 'smooth' });
    lbUpdateDots();
  }

  function lbUpdateDots() {
    if (!lbImgs) return;
    lbCounter.textContent = (lbCurrentIndex + 1) + ' / ' + lbImgs.length;
    var dotEls = lbDots.querySelectorAll('.stoberecke-lightbox__dot');
    for (var i = 0; i < dotEls.length; i++) {
      dotEls[i].classList.toggle('stoberecke-lightbox__dot--active', i === lbCurrentIndex);
    }
    /* Pfeile ein-/ausblenden */
    var prevBtn = lightbox.querySelector('.stoberecke-lightbox__arrow--prev');
    var nextBtn = lightbox.querySelector('.stoberecke-lightbox__arrow--next');
    if (prevBtn) prevBtn.style.visibility = lbCurrentIndex > 0 ? '' : 'hidden';
    if (nextBtn) nextBtn.style.visibility = lbCurrentIndex < lbImgs.length - 1 ? '' : 'hidden';
  }

  /* Klick/Tap auf Produktbild → Lightbox öffnen */
  function handleImageTap(img) {
    var card = img.closest('.stoberecke-card');
    if (!card) return;

    var cardImgs = card.querySelectorAll('.stoberecke-card__image');
    var images = [];
    var startIdx = 0;

    for (var i = 0; i < cardImgs.length; i++) {
      images.push({ src: cardImgs[i].src, alt: cardImgs[i].alt });
      if (cardImgs[i] === img) startIdx = i;
    }

    openLightbox(images, startIdx);
  }

  /* Tap/Click auf Bild → Lightbox.
     Verwendet pointerdown/pointerup — zuverlässiger auf iOS Safari
     in scrollbaren Containern. Prüft ob Finger sich bewegt hat (Swipe vs Tap). */
  (function () {
    var ptrDown = null;
    var MOVE_LIMIT = 12;

    feed.addEventListener('pointerdown', function (e) {
      if (!e.target.closest('.stoberecke-card__image')) return;
      ptrDown = { x: e.clientX, y: e.clientY, time: Date.now(), img: e.target.closest('.stoberecke-card__image') };
    });

    feed.addEventListener('pointerup', function (e) {
      if (!ptrDown) return;
      var dx = Math.abs(e.clientX - ptrDown.x);
      var dy = Math.abs(e.clientY - ptrDown.y);
      var dt = Date.now() - ptrDown.time;
      var img = ptrDown.img;
      ptrDown = null;

      /* Nur Tap (wenig Bewegung, kurze Dauer), kein Swipe */
      if (dx < MOVE_LIMIT && dy < MOVE_LIMIT && dt < 500) {
        handleImageTap(img);
      }
    });

    feed.addEventListener('pointercancel', function () {
      ptrDown = null;
    });
  })();

  /* -----------------------------------------------------------------------
     Hilfsfunktionen (XSS-Schutz)
     ----------------------------------------------------------------------- */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();
